enum SubjectEnum {
  READING = "Reading",
  MATH = "Math",
  SEL = "SEL",
  PURPOSE = "Purpose", //SEL and purpose refer to the same subject, including both for compatibility
  SCIENCE = "Science"
}

export default SubjectEnum;
